export enum SessionKeys {
    SEARCH_ID = 'searchId',
}
